import React from "react";
import Text from "@/components/ui/text";
import { useTranslation } from "react-i18next";
import { EmptyTasks } from "@dreamhub/designsystem/icons";
import { cn } from "@/utils/utils";

const TRANSLATION_KEY = "tasks.drawer";

interface Props {
  className?: string;
}

const EmptyTasksState: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn("h-[35rem] flex justify-center", className)}>
      <div className="flex flex-col gap-6 justify-center items-center">
        <EmptyTasks />
        <div className="flex flex-col gap-2 text-center">
          <Text variant="lgLabel">{t(`${TRANSLATION_KEY}.empty.title`)}</Text>
          <Text variant="bodySecondary">
            {t(`${TRANSLATION_KEY}.empty.subtitle`)}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default EmptyTasksState;
